// extracted by mini-css-extract-plugin
export default {"uniPlayPage":"UniPlayPage_uniPlayPage__nwrcZ","mainArea":"UniPlayPage_mainArea__re2TH","selectUniPlay":"UniPlayPage_selectUniPlay__qKGEZ"};